import { render } from "./StoreSettingsTable.vue?vue&type=template&id=2d23b846&scoped=true"
import script from "./StoreSettingsTable.vue?vue&type=script&lang=js"
export * from "./StoreSettingsTable.vue?vue&type=script&lang=js"

import "./StoreSettingsTable.vue?vue&type=style&index=0&id=2d23b846&lang=scss&scoped=true"
import "./StoreSettingsTable.vue?vue&type=style&index=1&id=2d23b846&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d23b846"]])

export default __exports__